import { DIALOG_IDS } from '@core/modal'

import { type TPaywallRequest } from '../types/paywallTypes'

import { PAYWALL_PRO_PRODUCT_IDS } from './paywallProducts'

export const WELCOME_OFFER_PAYWALL_REQUEST: TPaywallRequest = {
    variant: 'welcome-offer',
    modalType: 'welcome_offer',
    productIds: PAYWALL_PRO_PRODUCT_IDS,
    size: 'minified',
    analyticsTrigger: 'welcome_offer',
}

/** No `analyticsTrigger`: the caller picks the au4 one from the `mtm_source` it was opened with. */
export const AUDACITY_AUDIO_PAYWALL_REQUEST: TPaywallRequest = {
    variant: 'audacity-audio',
    modalType: 'reg_paywall',
    productIds: PAYWALL_PRO_PRODUCT_IDS,
    size: 'minified',
}

/** Free-plan owner turning transcription on — audio-web's TranscribingPaywallDialog. */
export const TRANSCRIPTION_PAYWALL_REQUEST: TPaywallRequest = {
    variant: 'transcription',
    modalType: 'reg_paywall',
    productIds: PAYWALL_PRO_PRODUCT_IDS,
    size: 'minified',
    analyticsTrigger: 'transcribe_toggle',
}

/**
 * Free-plan listener asking for HQ playback. No `analyticsTrigger`: audio-web arms `hq_player` in the
 * click handler, before the dialog opens, so its show event carries the trigger too.
 */
export const HQ_PAYWALL_REQUEST: TPaywallRequest = {
    variant: 'hq',
    modalType: 'reg_paywall',
    productIds: PAYWALL_PRO_PRODUCT_IDS,
    size: 'minified',
}

/** audio-web's `PostRegistrationDialog`. */
export const REG_PAYWALL_REQUEST: TPaywallRequest = {
    variant: 'reg',
    modalType: 'reg_paywall',
    productIds: PAYWALL_PRO_PRODUCT_IDS,
    size: 'minified',
    container: 'drawer',
}

export const OLD_USERS_PAYWALL_REQUEST: TPaywallRequest = {
    variant: 'old-users',
    modalType: 'discounted-offer-for-old-users',
    productIds: PAYWALL_PRO_PRODUCT_IDS,
    size: 'minified',
    analyticsTrigger: 'discounted-offer-for-old-users',
    flow: 'old-users',
}

export const CREATOR_PROFILE_OFFER_PAYWALL_REQUEST: TPaywallRequest = {
    variant: 'creator-offer',
    modalType: 'creator-profile-offer',
    productIds: PAYWALL_PRO_PRODUCT_IDS,
    size: 'minified',
    analyticsTrigger: 'creator-profile-offer',
    armsTriggerBeforeShow: true,
}

/** No `analyticsTrigger`: the compare step before it already armed `lossless-upload`. */
export const LOSSLESS_UPLOAD_PAYWALL_REQUEST: TPaywallRequest = {
    variant: 'lossless-upload',
    modalType: 'lossless-upload',
    productIds: PAYWALL_PRO_PRODUCT_IDS,
    size: 'minified',
    awaitsHqStorageBeforeCheckout: true,
}

/**
 * Free user reaching for a premium embed field. `returnTo` brings the embed dialog back on close —
 * audio-web re-opens it from the paywall's `onClose` with the form state it handed over.
 */
export const EMBED_PAYWALL_REQUEST: TPaywallRequest = {
    variant: 'embed',
    modalType: 'embed_custom',
    productIds: PAYWALL_PRO_PRODUCT_IDS,
    size: 'minified',
    analyticsTrigger: 'embed_custom',
    returnTo: DIALOG_IDS.embed,
}
